import BlankCanvasImage from '@images/undraw/blank-canvas.svg';
import Empty from 'antd/es/empty';

import ConversationPage from '@pages/team/[teamId]/workspace/conversations/[conversationId]';
import TaskListPage from '@pages/team/[teamId]/workspace/tasks';
import TaskDetailsPage from '@pages/team/[teamId]/workspace/tasks/[taskId]';
import AgentRunDetailsPage from '@pages/team/[teamId]/workspace/tasks/[taskId]/agent-runs/[agentRunId]';

export const workspaceRoutes = {
  path: 'workspace',
  children: [
    {
      path: '',
      element: (
        <Empty
          description="Select an item from the workspace to get started"
          image={
            <img
              src={BlankCanvasImage}
              alt="Blank Canvas"
              style={{ width: '100%', height: '100%' }}
            />
          }
          style={{ marginTop: 'clamp(100px, 20vh, 200px)' }}
        />
      ),
    },
    { path: 'conversations/:conversationId', element: <ConversationPage /> },
    { path: 'tasks', element: <TaskListPage /> },
    { path: 'tasks/:taskId', element: <TaskDetailsPage /> },
    {
      path: 'tasks/:taskId/agent-runs/:agentRunId',
      element: <AgentRunDetailsPage />,
    },
  ],
};
